import * as React from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

export default function MuiTimePicker({
    id = 'time-picker',
    name = 'timePicker',
    label = 'Mui Time Picker',
    value,
    error = false,
    fullWidth = false,
    required = false,
    onChange = () => {},
    disabled = false,
    readOnly = false,
    helperText = '',
    minTime,
    maxTime,
    slots = {},
    slotProps = {},
    onOpen = () => {},
    shouldDisableTime = () => {}
}) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
                shouldDisableTime={shouldDisableTime}
                label={label}
                value={dayjs(value)}
                reduceAnimations={true}
                disabled={disabled}
                readOnly={readOnly}
                onChange={onChange}
                minTime={minTime}
                ampm={false}
                ampmInClock={true}
                maxTime={maxTime}
                autoFocus={false}
                onOpen={onOpen}
                slots={{
                    ...slots
                }}
                closeOnSelect={false}
                disableIgnoringDatePartForTimeValidation={true}
                viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock
                }}
                slotProps={{
                    textField: {
                        helperText: helperText,
                        error: error,
                        fullWidth: fullWidth,
                        id: id,
                        name: name,
                        required: required,
                        sx: {
                            minWidth: '265px',
                            '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
                                {
                                    borderColor: error ? '#d32f2f !important' : '#f5f5f5 !important'
                                },
                            '.css-jupps9-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
                                {
                                    borderColor: error ? '#d32f2f !important' : '#f5f5f5 !important'
                                },
                            '.css-1n04w30-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
                                {
                                    borderColor: '#f5f5f5'
                                },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#f5f5f5',
                                '&.Mui-disabled ': {
                                    borderColor: error ? '#d32f2f !important' : '#f5f5f5 !important'
                                },
                                '&.Mui-error': {
                                    borderColor: error ? '#d32f2f !important' : '#f5f5f5 !important'
                                }
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '15px',
                                fontFamily: 'Nunito, sans-serif',
                                color: '#f5f5f5',
                                '& fieldset': {
                                    borderColor: '#f5f5f5'
                                },
                                '&:hover fieldset': {
                                    borderColor: '#f8a21e'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#f8a21e'
                                },
                                '&.Mui-disabled': {
                                    WebkitTextFillColor: '#f5f5f5 !important'
                                }
                            },
                            '& .MuiOutlinedInput-input': {
                                fontSize: '1.125rem',
                                '&.Mui-disabled': {
                                    WebkitTextFillColor: '#f5f5f5 !important'
                                }
                            },
                            '& .MuiInputLabel-root': {
                                color: '#f5f5f5 !important',
                                fontFamily: 'Noto Sans, sans-serif'
                            },
                            '& .MuiSvgIcon-root': {
                                fill: '#f5f5f5'
                            },
                            '& .MuiFormHelperText-root': {
                                color: '#f5f5f5',
                                margin: '6px 0px 0px 3px',
                                fontFamily: 'Nunito, sans-serif',
                                fontSize: '0.875rem',
                                lineHeight: 'none',
                                letterSpacing: '0px',
                                '&.Mui-error': {
                                    color: '#f44336'
                                },
                                '&.Mui-disabled': {
                                    color: error ? '#f44336' : '#f5f5f5'
                                }
                            }
                        }
                    },
                    desktopPaper: {
                        sx: {
                            background: 'rgba(0, 0, 0, 0.2)',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(14px)',
                            margin: '0',
                            borderRadius: '15px',
                            color: '#f5f5f5',
                            height: '320px',
                            fontFamily: 'Nunito, sans-serif !important',
                            '& .MuiTypography-root': {
                                color: '#f5f5f5',
                                fontWeight: '600',
                                fontFamily: 'Nunito, sans-serif !important',
                                fontSize: '0.875rem'
                            },
                            '& .MuiIconButton-root': {
                                color: '#f8a21e !important'
                            },
                            '& .MuiClock-pin': {
                                backgroundColor: '#f8a21e'
                            },
                            '& .MuiClockNumber-root': {
                                color: '#f5f5f5',
                                fontFamily: 'Nunito, sans-serif !important',
                                '&.Mui-selected': {
                                    background: '#f8a21e !important'
                                },
                                '&.Mui-disabled': {
                                    color: 'rgba(255,255,255,0.3) !important'
                                }
                            },
                            '& .MuiClockPointer-root': {
                                backgroundColor: '#f8a21e'
                            },
                            '& .MuiClockPointer-thumb': {
                                backgroundColor: '#f8a21e',
                                borderColor: '#f8a21e'
                            },
                            '& .MuiClock-amButton ': {
                                // border: '2px solid #f8a21e',
                                background: 'transparent',
                                height: '36px',
                                '&.Mui-selected': {
                                    backgroundColor: '#26c1e8',
                                    borderColor: 'transparent'
                                }
                            },
                            '& .MuiPickersArrowSwitcher-root': {
                                top: '6px',
                                right: '0'
                            },
                            '& .MuiClock-pmButton ': {
                                // border: '2px solid #f8a21e',
                                background: 'transparent',
                                height: '36px',
                                '&.Mui-selected': {
                                    backgroundColor: '#26c1e8',
                                    borderColor: 'transparent'
                                }
                            },
                            '& .MuiButton-text ': {
                                color: '#f5f5f5'
                            },
                            '& .MuiClock-clock': {
                                width: '230px',
                                height: '230px',
                                padding: '5px',
                                background: 'rgba(0, 0, 0, 0.25)',
                                boxShadow:
                                    'rgba(0, 0, 0, 0.16) 0px 6px 6px, rgba(0, 0, 0, 0.23) 0px 6px 6px, rgba(0, 0, 0, 0.16) 0px -3px 6px, rgba(0, 0, 0, 0.23) 0px -3px 6px'
                            },
                            '& .MuiButton-root': {
                                padding: '10px 4px 10px 12px',
                                fontFamily: 'Nunito, sans-serif !important',
                                '&:hover': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            '& .MuiDialogActions-root': {
                                padding: '0px'
                            }
                        }
                    },
                    ...slotProps
                }}
            />
        </LocalizationProvider>
    );
}
